import Text from 'components/Text/Text';
import React from 'react';
import PriceField from './components/PriceField';
import style from './PriceFilter.module.scss';

const PriceFilter: React.FC = () => {
	return (
		<div className={style.priceFilter} data-test="PriceFilter">
			<Text translationNameSpace="listing" translationKey="signedPriceLabel" theme="neutralLight" size="xs" />
			<div className={style.priceFields}>
				<PriceField type="from" />
				<PriceField type="to" />
			</div>
		</div>
	);
};

export default PriceFilter;
